<template>
  <div class="transition-global">
    <div
      class="totemBG tw-bg-cover tw-w-screen tw-h-screen tw-flex tw-flex-col"
    >
      <div class="tw-flex-none">
        <div class="tw-py-16 tw-text-center">
          <vLogoDefault />
        </div>
      </div>
      <div class="tw-flex-1 tw-justify-center tw-items-center">
        <div class="tw-text-white">
          <div id="pgqrpix" v-if="getCOMPRA.tipoCartao == 'PIX'">
            <div class="tw-font-bold tw-text-center tw-py-5 tw-text-6xl">
              Pagamento via Pix <br />
              <span v-if="mensagemPinpad" class="tw-text-4xl tw-font-bold">
                {{ mensagemPinpad.toUpperCase() }}
              </span>
            </div>

            <div class="tw-my-20 tw-text-center">
              <div
                v-if="dataImagem"
                class="tw-p-10 tw-inline-block tw-w-2/5 tw-mx-auto qrcodeBorder"
              >
                <img
                  class="tw-w-full tw-rounded-xl"
                  draggable="false"
                  @contextmenu.prevent
                  @dragstart.prevent
                  :src="dataImagem"
                />
              </div>
              <div
                v-else
                class="mockQRCODE tw-rounded-xl tw-justify-center tw-bg-white tw-mx-auto tw-grid"
              >
                <v-icon
                  color="black"
                  size="120"
                  class="tw-mx-auto tw-animate-spin"
                  >mdi-loading</v-icon
                >
              </div>
            </div>
            <div class="tw-my-20 tw-text-center">
              <div class="tw-text-center tw-text-3xl tw-text-white tw-mx-auto">
                Total da compra
              </div>
              <div
                class="tw-text-white tw-text-center tw-text-6xl tw-pt-3 tw-font-light"
              >
                {{ getPrice }}
              </div>
            </div>
            <div class="tw-text-center tw-mt-5">
              <div v-if="dataImagem">
                <button
                  :disabled="lockCancel"
                  @click="cancelarPagamento"
                  class="tw-text-4xl tw-w-2/3 tw-mx-auto tw-bg-red-700 tw-text-center tw-text-white tw-p-10 tw-rounded-md"
                >
                  <v-icon
                    v-if="lockCancel"
                    color="white"
                    size="60"
                    class="tw-animate-spin"
                    >mdi-loading</v-icon
                  >
                  <div v-else>CANCELAR PIX</div>
                </button>
              </div>
            </div>
          </div>
          <div id="pgtag" v-else-if="getCOMPRA.tipoCartao == 'TAG'">
            <vFullModal>
              <template v-slot:header>
                <div>
                  <div class="tw-text-6xl">
                    Seus melhores momentos <br />na palma da sua mão!
                  </div>
                  <div class="tw-text-5xl tw-mx-10 tw-mt-16 tw-font-light">
                    Aproxime sua TAG para revelar suas fotos
                    <div class="tw-pt-6">
                      <div
                        class="tw-pt-0 tw-text-4xl tw-uppercase tw-text-center tw-text-white"
                      >
                        Total da compra
                      </div>
                      <div
                        class="tw-text-6xl tw-py-5 tw-pb-10 tw-text-center tw-font-black tw-text-white"
                      >
                        {{ getPrice }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:footer>
                <div class="tw-mt-20">
                  <v-icon size="200" color="white" class="tw-animate-spin"
                    >mdi-loading</v-icon
                  >
                </div>
              </template>
            </vFullModal>
          </div>
          <div id="pgcard" v-else>
            <vFullModal>
              <template v-slot:header>
                <div>
                  <div class="tw-text-6xl">
                    Seus melhores momentos <br />na palma da sua mão!
                  </div>
                  <div class="tw-text-5xl tw-mx-10 tw-mt-16 tw-font-light">
                    Efetue o pagamento na máquina de cartão, para revelar suas
                    fotos
                    <div class="tw-pt-6">
                      <div
                        class="tw-pt-0 tw-text-4xl tw-uppercase tw-text-center tw-text-white"
                      >
                        Total da compra
                      </div>
                      <div
                        class="tw-text-6xl tw-py-5 tw-pb-10 tw-text-center tw-font-black tw-text-white"
                      >
                        {{ getPrice }}
                      </div>
                    </div>

                    <span
                      v-if="mensagemPinpad"
                      class="tw-text-4xl tw-font-bold"
                    >
                      {{ mensagemPinpad.toUpperCase() }}
                    </span>
                  </div>
                  <div class="tw-text-center tw-mt-5">
                    <div v-if="flagProcessando">
                      <button
                        :disabled="lockCancel"
                        @click="cancelarPagamento"
                        class="tw-text-4xl tw-w-2/3 tw-mx-auto tw-bg-red-700 tw-text-center tw-text-white tw-p-10 tw-rounded-md"
                      >
                        <v-icon
                          v-if="lockCancel"
                          color="white"
                          size="60"
                          class="tw-animate-spin"
                          >mdi-loading</v-icon
                        >
                        <div v-else>CANCELAR</div>
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:footer>
                <div class="tw-mt-20">
                  <v-icon size="200" color="white" class="tw-animate-spin"
                    >mdi-loading</v-icon
                  >
                </div>
              </template>
            </vFullModal>
          </div>
        </div>
      </div>
      <vFloatGuide :back="false" :next="false" />
      <vTimeout
        v-if="
          getCOMPRA.etapa &&
          getCOMPRA.etapa === $root.chapters().PAGAMENTO_PROCESSO
        "
        :segundos="$root.getTimeoutName($root.chapters().PAGAMENTO_PROCESSO)"
      />
    </div>
  </div>
</template>

<script>
import vFullModal from "@/components/vModalFullScreen.vue";
import vFloatGuide from "@/components/floatGuide.vue";
import servicePagamento from "@/service/pagamento";
import anime from "animejs";
import QRCode from "qrcode";
import {
  setEtapaCompra,
  incrementarUsosCupom,
  updateCompraInterface,
} from "../../../service/firebase";
import posthog from "@/posthog";
import { registrarCompraPaga } from "@/service/purchasePayment";

const TIMEOUT_ERROR = 1000;

export default {
  components: {
    vFullModal,
    vFloatGuide,
  },
  data() {
    return {
      lockCancel: false,
      dataImagem: "",
      mensagemPinpad: "",
      socket: null,
      flagProcessando: false,
    };
  },
  mounted() {
    this.animaMounted();
    this.iniciaPagamento();

    this.socket = new WebSocket("ws://localhost:9001/ws/pinpad");

    // Arrow function: com `function`, o `this` era o próprio WebSocket, então
    // `flagProcessando` nunca era ligado e o botão CANCELAR não aparecia
    // justamente quando o pinpad falhava — o cliente ficava sem saída.
    this.socket.onerror = () => {
      this.flagProcessando = true;
    };
    this.socket.onclose = () => {
      this.flagProcessando = true;
    };
    this.socket.onmessage = (event) => {
      this.mensagemPinpad = event.data;
      if (this.mensagemPinpad == "PROCESSANDO") {
        this.flagProcessando = true;
      }
    };
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.close();
    }
  },
  computed: {
    getCOMPRA() {
      return this.$store.getters["compra/getCompra"];
    },
    getPrice() {
      let valor = this.getCOMPRA.valor;
      let currency = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valor);
      return currency;
    },
  },
  methods: {
    cancelarPagamento() {
      this.lockCancel = true;
      servicePagamento
        .cancelarPagamento()
        .then(() => {})
        .catch(async () => {
          setEtapaCompra(this.$root.chapters().PAGAMENTO_FALHOU);
        });
    },
    gerarQRCODE(code) {
      if (!code) {
        this.$root.infoModal("Não foi possível gerar o QR Code do Pix.");
      }
      QRCode.toDataURL(code, { errorCorrectionLevel: "H" })
        .then((url) => {
          this.dataImagem = url;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    aguardandoPagamentoPix(resp) {
      const pagamento_id = resp.id;
      servicePagamento
        .aguardandoPagamentoPix(pagamento_id)
        .then(async () => {
          const compra = this.$store.getters["compra/getCompra"];
          if (compra.cupom && compra.cupom.id) {
            incrementarUsosCupom(compra.cupom.id);
          }
          // Atualizar campo pago antes de mudar etapa
          registrarCompraPaga(compra);
          await updateCompraInterface(compra);
          posthog.capture("payment_completed", {
            payment_method: "PIX",
            purchase_value: compra.valor,
          });
          setEtapaCompra(this.$root.chapters().PAGAMENTO_SUCESSO);
        })
        .catch(async () => {
          await this.delay(TIMEOUT_ERROR);
          setEtapaCompra(this.$root.chapters().PAGAMENTO_FALHOU);
        });
    },
    iniciaPix(compra) {
      servicePagamento
        .gerarPix(compra.valor)
        .then((resp) => {
          this.gerarQRCODE(resp.data.url);
          this.aguardandoPagamentoPix(resp.data);
        })
        .catch(async () => {
          await this.delay(TIMEOUT_ERROR);
          setEtapaCompra(this.$root.chapters().PAGAMENTO_FALHOU);
        });
    },
    iniciaPagamento() {
      const compra = this.$store.getters["compra/getCompra"];
      if (!["PIX", "TAG", "Credito", "Debito"].includes(compra?.tipoCartao)) {
        this.$root.infoModal("Forma de pagamento ausente. Selecione novamente antes de cobrar.");
        setEtapaCompra(this.$root.chapters().PAGAMENTO_FALHOU);
        return;
      }
      if (compra.tipoCartao === "PIX") {
        this.iniciaPix(compra);
      } else if (compra.tipoCartao === "TAG") {
        this.iniciarTag(compra);
      } else {
        this.iniciarMaquininha(compra);
      }
    },
    iniciarTag(compra) {
      const config = this.$store.getters["totem/getTotem"].config || {};
      servicePagamento
        .pagamentoNfc({
          authToken: config.multiclubes_auth_token,
          posEid: config.multiclubes_pos_eid,
          productCode: compra.codigo_produto,
          quantity: compra.qtde_foto,
        })
        .then(async () => {
          if (compra.cupom && compra.cupom.id) {
            incrementarUsosCupom(compra.cupom.id);
          }
          // Atualizar campo pago antes de mudar etapa
          registrarCompraPaga(compra);
          await updateCompraInterface(compra);
          setEtapaCompra(this.$root.chapters().PAGAMENTO_SUCESSO);
        })
        .catch(async () => {
          await this.delay(TIMEOUT_ERROR);
          setEtapaCompra(this.$root.chapters().PAGAMENTO_FALHOU);
        });
    },
    iniciarMaquininha(compra) {
      servicePagamento
        .gerarPagamento(compra.tipoCartao, compra.valor)
        .then(async () => {
          if (compra.cupom && compra.cupom.id) {
            incrementarUsosCupom(compra.cupom.id);
          }
          // Atualizar campo pago antes de mudar etapa
          registrarCompraPaga(compra);
          await updateCompraInterface(compra);
          posthog.capture("payment_completed", {
            payment_method: compra.tipoCartao,
            purchase_value: compra.valor,
          });
          setEtapaCompra(this.$root.chapters().PAGAMENTO_SUCESSO);
        })
        .catch(async () => {
          await this.delay(TIMEOUT_ERROR);
          setEtapaCompra(this.$root.chapters().PAGAMENTO_FALHOU);
        });
    },
    animaMounted() {
      anime({
        targets: ".transition-global",
        opacity: {
          value: 1,
          delay: 0,
          duration: 1000,
          easing: "easeInOutExpo",
        },
      });
    },
    delay(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mockQRCODE {
  width: 432px;
  height: 432px;
}
.totemBG {
  background-image: linear-gradient(
      180deg,
      #978fc4 0%,
      #a78ebd 34.84%,
      rgba(207, 138, 172, 0.8) 100%
    ),
    url("../../../assets/fundo.png");
}
.transition-global {
  opacity: 0;
}
.header-text {
  color: #3d5a80;
  font-size: 28px;
  line-height: 29px;
}
.textBody {
  color: #4a4a4a;
  font-family: "Roboto", sans-serif;
}
.qrcodeBorder {
  background-image: url("../../../assets/qrcode-border.svg");
  background-size: contain;
}
</style>
